import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import ShortText from './ShortText'
import Email from './Email'
import Address from './Address'
import SingleChoice from './SingleChoice'
import LongText from './LongText'
import FileUpload from './FileUpload'

const ArtsAndCraftFairApplicationForm = () => {



    const productCategoryData = [
        {
            id: 1,
            label: 'لوازم جانبی / جواهرات',
            checked: false
        },
        {
            id: 2,
            label: 'هنر / کتاب‌ها و مجلات / موسیقی',
            checked: false
        },
        {
            id: 3,
            label: 'حمام و زیبایی',
            checked: false
        },
        {
            id: 4,
            label: 'شمع‌ها',
            checked: false
        },
        {
            id: 5,
            label: 'سرامیک و سفال / شیشه / نجاری',
            checked: false
        },
        {
            id: 6,
            label: 'کودکان',
            checked: false
        },
        {
            id: 7,
            label: 'پوشاک',
            checked: false
        },
        {
            id: 8,
            label: 'قلاب‌بافی / گلدوزی / بافتنی / صنایع دستی با سوزن',
            checked: false
        },
        {
            id: 9,
            label: 'عروسک‌ها و مینیاتورها',
            checked: false
        },
        {
            id: 10,
            label: 'مبلمان',
            checked: false
        },
        {
            id: 11,
            label: 'تعطیلات / عروسی‌ها',
            checked: false
        },
        {
            id: 12,
            label: 'لوازم خانگی',
            checked: false
        },
        {
            id: 13,
            label: 'محصولات کاغذی',
            checked: false
        },
        {
            id: 14,
            label: 'الگوها',
            checked: false
        },
        {
            id: 15,
            label: 'حیوانات خانگی',
            checked: false
        },
        {
            id: 16,
            label: 'گیاهان و خوراکی‌ها',
            checked: false
        },
        {
            id: 17,
            label: 'لحاف‌ها',
            checked: false
        },
        {
            id: 18,
            label: 'اسباب‌بازی‌ها',
            checked: false
        },
        {
            id: 19,
            label: 'قدیمی / وینتیج',
            checked: false
        },
        {
            id: 20,
            label: 'سایر موارد',
            checked: false
        }
    ]



    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم درخواست نمایشگاه هنر و صنایع دستی'} subHeader={'برای شرکت در نمایشگاه هنر و نمایشگاه، فرم زیر را با دقت پر کنید. فرم‌هایی که به طور کامل پر نشده باشند، پذیرفته نخواهند شد.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <ShortText header={'نام شرکت'} />
                <Email header={'ایمیل'} />
                <Address header={'آدرس'} />
                <SingleChoice header={'دسته بندی محصولات'} options={productCategoryData} />
                <LongText header={'شرح محصولات شما:'} />
                <ShortText header={'محدوده قیمت محصولات شما:'} />
                <FileUpload header={'عکس‌های محصولات خود را اینجا ضمیمه کنید:'} />
                <Heading header={'صفحات اجتماعی'} />
                <ShortText header={'وبلاگ:'} />
                <ShortText header={'شناسه توییتر:'} />
                <ShortText header={'ضرب کنید:'} />
                <ShortText header={'صفحه مای اسپیس:'} />
                <ShortText header={'صفحه طرفداران در فیسبوک:'} />
                <ShortText header={'وب‌سایت:'} />
                <LongText header={'نظرات/سوالات تکمیلی:'} />
            </Grid>
        </Grid>
    )
}

export default ArtsAndCraftFairApplicationForm
